import React, { useEffect } from 'react'
import { Box, Typography, IconButton } from '@mui/material'
import { format, addMonths, subMonths, isToday } from 'date-fns'
import useDates from 'services/hooks/useDate'

import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded'
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded'
import AdxButton from 'components/custom/AdxButton'

const CalendarToggler = ({ setCalendarValue, calendarValue, handleClick, md, sm }) => {
  const { currentMonth } = useDates({ date: calendarValue })

  useEffect(() => {
    if (isToday(calendarValue)) {
      const index = currentMonth.findIndex((day) => isToday(day.object))
      handleClick(index)
    } else {
      //calendar will scroll to top calendar
      handleClick(0)
    }
  }, [calendarValue, currentMonth, handleClick])

  const goToday = () => {
    setCalendarValue(new Date())
  }

  const nextMonth = () => {
    setCalendarValue(addMonths(calendarValue, 1))
  }

  const prevMonth = () => {
    setCalendarValue(subMonths(calendarValue, 1))
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        justifyContent: md ? 'start' : 'space-between',
        width: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton
          sx={{ border: '1px solid #DADCE0', color: 'light-gray-text.main', borderRadius: '3.5px' }}
          onClick={prevMonth}
        >
          <ChevronLeftRoundedIcon />
        </IconButton>

        <Typography variant="h4" textAlign="center" minWidth={140}>
          {format(calendarValue, 'MMMM yyyy')}
        </Typography>

        <IconButton
          sx={{ border: '1px solid #DADCE0', color: 'light-gray-text.main', borderRadius: '3.5px' }}
          onClick={nextMonth}
        >
          <ChevronRightRoundedIcon />
        </IconButton>
      </Box>
      <AdxButton variant={'outlined'} onClick={goToday}>
        Today
      </AdxButton>
    </Box>
  )
}

export default CalendarToggler
